import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import carpet1 from '../../assets/images/carpet/carpet-1.jpg'
import carpet11 from '../../assets/images/carpet/carpet-11.jpg'

import carpet2 from '../../assets/images/carpet/carpet-2.jpg'
import carpet22 from '../../assets/images/carpet/carpet-22.jpg'

import carpet3 from '../../assets/images/carpet/carpet-3.jpg'
import carpet33 from '../../assets/images/carpet/carpet-33.jpg'

import carpet4 from '../../assets/images/carpet/carpet-4.jpg'
import carpet44 from '../../assets/images/carpet/carpet-44.jpg'
import { Link } from "react-router-dom";

const products = [
  {
    id: 1,
    title: "DustBin",
    price: "$39.01",
    primaryImage: carpet1,
    hoverImage: carpet11,
    review: 3,
    swatches: ["black", "maroon"],
     url: "/dustbin",
  },
  {
    id: 2,
    title: "Bed Linen",
    price: "$299.01",
    primaryImage: carpet2,
    hoverImage: carpet22,
    review: 4,
    swatches: ["gray", "red", "orange", "yellow"],
    url: "/dustbin",
  },
  {
    id: 3,
    title: "Bath Mat",
    price: "$399.01",
    primaryImage: carpet3,
    hoverImage: carpet33,
    review: 4,
    swatches: ["navy", "green", "gray", "aqua", "orange"],
    url: "/dustbin",
  },
  {
    id: 4,
    title: "Zigzag Carpet",
    price: "$199.01",
    primaryImage: carpet4,
    hoverImage: carpet44,
    url: "/dustbin",
  },
];

function FreshArrivals() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="section product-slider" style={{ background: "#FFF"}}>
      <div className="container"> 
      <div className="section-header">
        <h2> New Arrivals </h2>
        {/* <p> Shop our new arrivals from established brands </p> */}
      </div>

      <Slider {...settings} className="productSlider grid-products">
        {products.map((product) => (
          <div key={product.id} className="col-12 item">
            <div className="product-image">
             <Link to={product.url} className="product-img">
                <img
                  className="primary"
                  src={product.primaryImage}
                  alt={product.title}
                />
                <img
                  className="hover"
                  src={product.hoverImage}
                  alt={`${product.title} hover`}
                />
              </Link>

              <div className="button-set style1">
                <ul>
                  <li>
                    <Link to="/"  className="btn-icon btn btn-addto-cart">
                      <i className="icon anm bi bi-bag"></i>
                      <span className="tooltip-label">Add to Cart</span>
                    </Link>
                  </li>
                 
                  <li>
                    <Link to="/" className="btn-icon wishlist">
                      <i className="icon anm bi bi-heart"></i>
                      <span className="tooltip-label">Add To Wishlist</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="product-details text-center">
              <div className="product-name">
                <Link to="product-layout1.html">{product.title} </Link>
              </div>
              {/* <div className="product-price">
                <span className="price">{product.price}</span>
              </div> */}
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </div>
  );
}
export default FreshArrivals;
